import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";

const NotFound = () => (
  <div className="min-h-screen bg-[#050B14] text-white flex items-center justify-center px-6" data-testid="not-found-page">
    <div className="text-center max-w-md">
      <Wordmark className="h-12 mx-auto mb-10" />
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400 mb-3">404</p>
      <h1 className="font-heading text-4xl font-black tracking-tighter">Page off the flow.</h1>
      <p className="mt-3 text-slate-400 text-sm">That route doesn't exist. Let's get you back.</p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-8 inline-block px-6 py-3 bg-[#00F0FF] text-[#050B14] font-bold rounded-sm hover:bg-[#33F3FF]"
      >
        Back to ClydeFlow
      </Link>
    </div>
  </div>
);

export default NotFound;
